import { useEffect, useState } from "react";

const navLinks = [
  { href: "#vip", label: "会员特权" },
  { href: "#hot", label: "热门漫画" },
  { href: "#category", label: "漫画分类" },
  { href: "#experience", label: "阅读体验" },
  { href: "#pricing", label: "尊享套餐" },
  { href: "#reviews", label: "读者口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-950/95 backdrop-blur-md border-b border-background-700/60"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
            <i className="ri-gemini-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-50 md:text-xl">
            韩漫<span className="text-gradient-gold">土豪</span>漫画网
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-200 transition-colors hover:bg-background-800/60 hover:text-primary-300"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#pricing"
            className="whitespace-nowrap rounded-md border border-primary-500/60 px-4 py-2 text-sm font-medium text-primary-300 transition-colors hover:bg-primary-500/10"
          >
            登录
          </a>
          <a
            href="#pricing"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
          >
            立即开通 VIP
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-100 lg:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-700/60 px-4 pb-5 pt-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-200 transition-colors hover:bg-background-800/60 hover:text-primary-300"
              >
                {link.label}
              </a>
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <a
              href="#pricing"
              className="whitespace-nowrap rounded-md border border-primary-500/60 px-4 py-2.5 text-center text-sm font-medium text-primary-300"
            >
              登录
            </a>
            <a
              href="#pricing"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-950"
            >
              立即开通 VIP
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}